import { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';
import { Clients, SearchQuery, SuggestQuery } from '@xiag-search/sdk';
import { getClients } from 'src/selectors/getClients';
import { getDnt } from 'src/selectors/getDnt';

export function* searchRequestSdk(query: SearchQuery): SagaIterator {
    const { searchClient }: Clients = yield select(getClients);
    const dnt = yield select(getDnt);
    return yield call({ fn: searchClient.search, context: searchClient }, { ...query, dnt });
}

export function* suggestRequestSdk(query: SuggestQuery): SagaIterator {
    const { searchClient }: Clients = yield select(getClients);
    return yield call({ fn: searchClient.suggest, context: searchClient }, { ...query, source: ['keyPhrase'] });
}
